<button class="navigable-element ion-activatable"><ng-content></ng-content><ion-ripple-effect></ion-ripple-effect></button>